import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  @Input() name: string;
  @Input() type: string;
  @Input() disable: boolean;
  @Input() iconType: string;
  @Input() tooltiptext: string;
  @Input() textTransformNone = false;
  @Output() btnClick = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  public onClick(): void {
    if(typeof this.disable === 'undefined' || !this.disable) {
      this.btnClick.emit();
    }
  }

  public getClasses(): string {
    let className = '';
    if(this.type) {
      className = className + ' ' + this.type;
    }
    if (this.disable) {       
      className = className + ' ' + 'disable-btn';
    } 
    if(this.textTransformNone) { 
      className = className + ' ' + 'text-transform-none';
    }
    return className;
  }

}
